import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { getRegionText } from "CMS/utils";
import { useLoaderData } from "react-router";
import { cdn } from "utilities/cdnUtils";
import { formatTimeZone, getTimeZoneFromIana } from "shared/utils/dateTimeUtils";

const CountryListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.CountryListFrontModel>();
  return <ListTemplate
    title={viewModel.pageTitle}
    filterSet="country_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Country.Paginated}
    getId={item => item.countryId}
    layout={{
      type: "table",
      columns: [
        {
          key: "title",
          header: RESX.GeneralLabels.Title,
          render: item => <SmallDetails
            label={item.name}
            link={routes.country_Detail(item.countryId).absolute}
            subLabel={getRegionText(item.region)}
          />,
          size: "1fr",
        }, {
          key: "code",
          header: RESX.Bookkeeping.Code,
          render: item => item.code
        }, {
          key: "numberAndDateTimezone",
          header: `${RESX.Language.resxLanguage} / ${RESX.DateTime.Timezone}`,
          render: item => <SmallDetails
            label={item.cultureName}
            subLabel={formatTimeZone(getTimeZoneFromIana(item.ianaTimeZoneId, site.culture.uiLocale))}
          />,
          size: "2fr",
        }, {
          key: "callingCode",
          header: RESX.GeneralLabels.CallingCode,
          render: item => `+${item.callingCode}`,
        }, {
          key: "inEU",
          header: RESX.VatNumber.InEU,
          render: item => {
            if (!item.isEuMember) {
              return null;
            }

            return <img
              src={cdn.static("/images/flag_eu.png")}
              style={{ height: 20 }}
            />
          }
        }
      ]
    }}
    filters={<>
      <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
    </>}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
  />
};

export default CountryListApp;